export enum ESearchSuggestionItemType {
  text = 'text',
  category = 'category',
  shop = 'shop',
}